/* Source: /app/components/Mobile/MobileFAB.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Play, ArrowRightLeft, Loader2 } from "lucide-react";
import { cn } from "../../lib/utils.js";
function MobileFAB(props) {
  let mode = (props.mode || "jac");
  let activePanel = (props.activePanel || "code");
  let onRun = props.onRun;
  let onConvert = props.onConvert;
  let isRunning = (props.isRunning || false);
  let isConverting = (props.isConverting || false);
  let envReady = (props.envReady || false);
  let shouldShow = ((activePanel === "code") || (activePanel === "mode"));
  if (!shouldShow) {
    return null;
  }
  let isJacMode = (mode === "jac");
  let isConversionMode = ((mode === "jac2py") || (mode === "py2jac"));
  let isLoading = (isRunning || isConverting);
  let isDisabled = (isLoading || !envReady);
  function handlePress() {
    if (isDisabled) {
      return null;
    }
    if ((isJacMode && onRun)) {
      onRun();
    } else if ((isConversionMode && onConvert)) {
      onConvert();
    }
  }
  let Icon = ((isJacMode && Play) || ArrowRightLeft);
  let label = ((isJacMode && "Run Code") || "Convert");
  return __jacJsx("button", {"onClick": handlePress, "disabled": isDisabled, "className": cn("fixed bottom-20 right-4 w-14 h-14 rounded-full shadow-lg", "flex items-center justify-center z-[1000]", "transition-all duration-200 active:scale-95", ((!envReady && "bg-border cursor-not-allowed opacity-50") || ((isLoading && "bg-primary/70 cursor-wait") || "bg-primary hover:bg-primary/90")), "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"), "aria-label": ((envReady && label) || "Environment loading..."), "aria-pressed": isLoading}, [(isLoading && __jacJsx(Loader2, {"className": "w-6 h-6 text-primary-foreground animate-spin"}, [])), (!isLoading && __jacJsx(Icon, {"className": cn("w-6 h-6", ((!envReady && "text-text-secondary") || "text-primary-foreground"))}, []))]);
}
export {MobileFAB};